import React, { useState, useEffect } from "react";
import './credit.scss';
import CreditDashboard from "./dashbaordboxchanges";
import PolicyDetails from "../Analysis/policyDetailsNew";
import WorkingHistory from "../Analysis/workingHistory";
import { APIS } from "../../../../utils/api-factory";
import { ROLE } from "../../../../utils/Constant";
import Repeat from "./Analysis/repeatAutomation";
import CategorHistory from "../Analysis/savedCategoryuser";
import CreditCrifDashboard from "./Analysis/CreditDashboard/CreditCrifDashboard";
import { getSourceOfStatementParse } from "../AdminActionCreator.component";
// import AnalysisChecklist from './AnalysisChecklist';
import AutoAprrovalChecklist from "./AutoApprovalChecks/AutoAprrovalChecklist";
import { CHECK_COMPANY_TENANT, DREAM_SUPPORTER_LIKE } from "../../../../layouts/MainTenantconfig";
// import PolicyConfigs from "./CreditNew/PolicyConfigs";

// import CreditMainNew from './CreditMain/Main'
import CreditMainNew from './CreditNewNew/Main'
const MainTab = ({ allDetail, admin, tenant }) => {
    const [viewPage, setViewPage] = useState('dashboard');
    const [internalViewState, setInternalViewState] = useState(false);
    const [repeatUserData, setRepeatUserData] = useState(false);
    const [statementSource, setStatementSource] = useState('');
    const [repeatEmpId, setRepeatEmpId] = useState([]);
    const [empIds, setEmpIds] = useState([]);

    useEffect(() => {
        if (CHECK_COMPANY_TENANT(DREAM_SUPPORTER_LIKE)) {
            pageHandler("MAINcredit")
        }
    }, [])

    const pageHandler = (data) => {
        setViewPage(data);
    };
    const changeViewState = () => {
        console.log('mjh')
        setInternalViewState(!internalViewState)
    }

    const checkRepeatUser = () => {
        fetch(`${APIS.REPEAT_USER_CHECK}${allDetail.userId}`)
            .then(res => res.json())
            .then(json => {
                setRepeatUserData(json.repeatUser);
            });
    };

    const getSource = () => {
        getSourceOfStatementParse(allDetail.userId, callback => {
            setStatementSource(callback);
        });
    };

    const getEmployeesRepeat = () => {
        fetch(`${APIS.GET_ASSIGN_BY_STATUS}?status=repeat`)
            .then(res => res.json())
            .then(res => {
                setRepeatEmpId(res);
                const uniqueEmailIds = [...new Set(res.map(item => item.emailId))];
                setEmpIds(uniqueEmailIds);
            });
    };

    // useEffect(() => {
    //     checkRepeatUser();
    //     getSource();
    //     getEmployeesRepeat();
    // }, []);

    return (
        <>
            {
                !(CHECK_COMPANY_TENANT(DREAM_SUPPORTER_LIKE)) ?
                    <div className="container-fluid credit-module full-height">
                        <div className="row fixed-top" style={{ marginTop: '80px', zIndex: '1', background: '#fff', borderTop: '0.5px solid grey' }}>
                            <div className="btn-group btn-grp-credit" role="group" aria-label="onboard-btn" style={{ fontSize: '14px', maxWidth: 'max-content' }}>
                                <button className={`btn btn-outline-primary ${viewPage === "dashboard" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('dashboard')}> Dashboard</button>


                                {/* <button className={`btn btn-outline-primary ${viewPage === "history" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('history')}> Working History</button> */}

                                <button className={`btn btn-outline-primary ${viewPage === "scorehistory" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('scorehistory')}> Score Analysis</button>

                                <button className={`btn btn-outline-primary ${viewPage === "policy" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('policy')}> Policy Check</button>
                                {/* <button className={`btn btn-outline-primary ${viewPage === "Checklist" ? "analysisTopTabs" : ""}`} style={{width: '200px', background: '#fff', color:  '#00000073', borderBottom:  '2px solid #DBE9FF'  }} onClick={() => pageHandler('Checklist')}> Checklist</button> */}
                                <button className={`btn btn-outline-primary ${viewPage === "Crif" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('Crif')}> Crif</button>

                                <button className={`btn btn-outline-primary ${viewPage === "AutoApprovalchecklist" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('AutoApprovalchecklist')}>Auto Approval Checklist</button>


                                {repeatUserData && admin?.rolelist.includes(ROLE.CRIF_DATA) && empIds.includes(admin.emailId) && (
                                    <button className={`btn btn-outline-primary ${viewPage === "repeatAutomation" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('repeatAutomation')}> Repeat Automation Decision</button>
                                )}
                                {repeatUserData && (admin.emailId === 'SuperUser') && (
                                    <button className={`btn btn-outline-primary ${viewPage === "repeatAutomation" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('repeatAutomation')}> Repeat Automation Decision</button>
                                )}
                            </div>
                        </div>
                        {
                            viewPage === 'Crif' &&
                            <div style={{ paddingTop: '30px' }}>
                                <CreditCrifDashboard admin={admin} allDetail={allDetail} />
                            </div>
                        }
                        {viewPage === 'AutoApprovalchecklist' &&
                            <div>
                                <AutoAprrovalChecklist admin={admin} allDetail={allDetail} />
                            </div>
                        }
                        <div style={{ marginTop: viewPage === 'Crif' ? '0' : '120px' }}>
                            {viewPage === 'dashboard' &&
                                <CreditDashboard statementSource={statementSource} changeViewState={changeViewState} internalViewState={internalViewState} admin={admin} allDetail={allDetail} tenant={tenant} />

                            }
                        </div>
                        {/* <div>
                {viewPage === 'Checklist' && <AnalysisChecklist admin={admin} allDetail={allDetail} />}
            </div> */}
                        <div style={{ marginTop: viewPage === 'Crif' ? '0' : '170px' }}>
                            {viewPage === 'policy' && <PolicyDetails allDetail={allDetail} admin={admin} />}
                        </div>
                        <div style={{ marginTop: viewPage === 'Crif' ? '0' : '120px' }}>
                            {viewPage === 'history' && <WorkingHistory allDetail={allDetail} />}
                        </div>
                        <div>
                            {viewPage === 'scorehistory' && <CategorHistory admin={admin} allDetail={allDetail} />}
                        </div>
                        <div style={{ marginTop: viewPage === 'Crif' ? '0' : '120px' }}>
                            {viewPage === 'repeatAutomation' && <Repeat allDetail={allDetail} admin={admin} />}
                        </div>

                    </div>
                    : ""}

            {
                 CHECK_COMPANY_TENANT(DREAM_SUPPORTER_LIKE) ?
                    <CustomDashTabs admin={admin} allDetail={allDetail} pageHandler={pageHandler} viewPage={viewPage} />
                    : ""}
        </>
    );
};

export default MainTab;


const CustomDashTabs = ({ admin, allDetail, pageHandler, viewPage }) => {

    return (
        <>
            <div className="container-fluid credit-module full-height">
                <div className="row fixed-top" style={{
                    marginTop: '85px', zIndex: '1',
                    background: '#F9FAFB',
                    // background: '#fff', 
                    borderTop: '0.5px solid grey'
                }}>
                    {/* <div className="btn-group btn-grp-credit" role="group" aria-label="onboard-btn" style={{ fontSize: '14px', maxWidth: 'max-content' }}>
                        <button className={`btn btn-outline-primary ${viewPage === "MAINcredit" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('MAINcredit')}>Financial Assessment</button>
                        <button className={`btn btn-outline-primary ${viewPage === "MAINcreditPolicy" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('MAINcreditPolicy')}> Policy Checks</button>



                    </div> */}
                </div>
                <div style={{ marginTop: '0px' }}>
                    {
                        viewPage == "MAINcredit" ?
                            <CreditMainNew admin={admin} allDetail={allDetail} />
                            : ""}
                   
                </div>
            </div>
        </>
    )
}
